import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const McdInvSlaCartesianChart = ({ selectedStates = [], selectedPeriod, selectedCtrts = [], selectedDueDate }) => {

  const rsrc = useRsrc();
  const [data, setData] = useState();

  // const data = {
  //   categories: ['1', '2', '3', '4', '5', '6', '7+'],
  //   series: [
  //     {
  //       label: 'Summary Loaded',
  //       values: [3, 5, 6, 0, 1, 0, 1],
  //       type: 'column',
  //       color: '#f7bba1ff',
  //     },
  //     {
  //       label: 'Authorized',
  //       values: [2, 3, 5, 1, 0, 0, 0],
  //       type: 'column',
  //       color: '#f6b1b3ff',
  //     },
  //     {
  //       label: 'Disputes Loaded',
  //       values: [1, 1, 0, 2, 1, 0, 0],
  //       type: 'column',
  //       color: '#f6b65cff',
  //     },
  //     {
  //       label: 'Routed',
  //       values: [10, 0, 0, 0, 0, 0, 0],
  //       type: 'column',
  //       color: '#f7cf44ff',
  //     },
  //     {
  //       label: 'Approved',
  //       values: [2, 7, 1, 1, 0, 1, 0],
  //       type: 'column',
  //       color: '#f4e04fff',
  //     }
  //   ],
  // };

  useEffect(() => {
    if (!selectedPeriod?.id) {
      return;
    }
    
    const stateIds = selectedStates.map(state => state.id);
    const ctrtIds = selectedCtrts.map(ctrt => ctrt.id);
    const reqParam = {
      periodId: selectedPeriod?.id,
      stateIds,
      ctrtIds,
      dueDate: selectedDueDate?.value
    };

    rsrc.data('sc', 'MCD_INV_SLA_CARTESIAN_DATA_PLUGIN', reqParam).then(data => {
      setData(data);
    });
  }, [selectedStates, selectedPeriod, selectedCtrts, selectedDueDate]);


  return (
    <CartesianChart
      data={data}
      xLabel="Days to Complete"
      yLabel="Invoice Count"
      legend="bottom"
      stacked={false}
      horizontal={false}
    />
  );
};
